export default "__VITE_ASSET__49e572cd__"